import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AAuthCodeFlowService, ModernAuthentication } from "@coso/connection-forms";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { handleError } from "../utils/handle-error";

@Injectable({
  providedIn: "root"
})
export class AuthCodeFlowService extends AAuthCodeFlowService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/auth-code-flow`;
  }

  constructor(private http: HttpClient) {
    super();
  }

  acquireToken(code: string, modernAuthentication: ModernAuthentication): Observable<string> {
    const authentication = {
      aadInstance: modernAuthentication.azureEndpoint,
      clientId: modernAuthentication.clientId,
      tenantId: modernAuthentication.tenantId,
      scope: modernAuthentication.scope,
      clientSecret: modernAuthentication.clientSecret,
      tokenResponse: modernAuthentication.encryptedToken
    };
    const instanceId = sessionStorage.getItem("instance-id");
    const authorizationCodeUrl = `${window.location.origin}/consent-callback?code=${code}`;
    const params = new HttpParams().append("authorizationCodeUrl", authorizationCodeUrl);
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post(`${baseRoute}/token-response`, authentication, { params: params, responseType: "text" }).pipe(catchError((error) => throwError(handleError(error))));
  }
}
